module.exports = __webpack_public_path__ + "img/Syg_icon_tewtsdf.c762264c.png";